{
  "kui": {
    "popoutComboBox": {
      "searchPlaceholder": "Search...",
      "noResults": "No options",
      "triggerAriaLabel": "Filter by {label}",
      "clearAriaLabel": "Clear {label} filter",
      "allLabel": "All"
    },
    "contentCombobox": {
      "addOption": "Add “{value}”",
      "blankOption": "A label can’t be blank",
      "clearSelection": "Clear selection",
      "loading": "Loading...",
      "optionTooLong": "Labels can be up to {max} characters",
      "removeOption": "Remove {value}"
    },
    "popoutCascade": {
      "change": "Change",
      "endOfChain": "Nothing further to narrow by."
    },
    "feedback": {
      "pickedNeutral": "Thanks! What would make this more useful?",
      "pickedNegative": "Sorry to hear that. What was missing?"
    },
    "auth": {
      "continueWithClever": "Continue with Clever",
      "continueWithFakeClever": "Continue with Clever (fake)",
      "confirmItsYou": "Let’s confirm it’s you",
      "methodDescription": "We can email you a one-time code, or you can use your password.",
      "emailMeACode": "Email me a code",
      "usePasswordInstead": "Use a password instead",
      "enterYourPassword": "Enter your password",
      "forgotPasswordUseCode": "Email me a code instead",
      "forgotPassword": "Forgot password?",
      "invalidCredentials": "Incorrect email or password.",
      "createPasswordHeading": "Create a password",
      "createPasswordDescription": "Log in without waiting for an emailed code. You can always add one later from your profile.",
      "createPasswordButton": "Save password",
      "skipForNow": "Skip for now",
      "accessDenied": "Access Denied",
      "loginWithAnotherEmail": "Log in with another email",
      "mfaChallenge": {
        "title": "Two-step verification",
        "description": "Enter the 6-digit code from your authenticator app.",
        "codeLabel": "Authentication code",
        "recoveryCodeLabel": "Recovery code",
        "recoveryCodeRequired": "Enter one of your recovery codes",
        "submit": "Verify",
        "useRecoveryCode": "Use a recovery code instead",
        "useAuthenticatorCode": "Use your authenticator app instead"
      },
      "mfaEnrol": {
        "title": "Set up two-step verification",
        "description": "Admin accounts need an authenticator app to sign in.",
        "scanStep": "Scan this QR code with your authenticator app, or enter the setup key by hand.",
        "qrCodeAlt": "QR code to add Anyway to your authenticator app",
        "setupKeyLabel": "Setup key",
        "copy": "Copy key",
        "copied": "Copied",
        "codeStep": "Then enter the 6-digit code your app shows to finish setup.",
        "submit": "Confirm",
        "loadFailed": "We could not start the setup. Please try again.",
        "retry": "Try again"
      },
      "mfaRecoveryCodes": {
        "title": "Save your recovery codes",
        "warning": "If you lose your authenticator app, each of these codes signs you in once. They will not be shown again, so save them somewhere safe now.",
        "copy": "Copy codes",
        "copied": "Copied",
        "copyFailed": "The codes could not be copied. Download them instead.",
        "download": "Download",
        "saved": "I have saved these codes"
      },
      "mfaExpired": "Your sign-in has timed out. Please start again.",
      "mfaStartAgain": "Start again",
      "mfaSignOut": "Sign out"
    },
    "form": {
      "noChanges": "Make a change to save."
    },
    "password": {
      "label": "Password",
      "placeholder": "Your password",
      "show": "Show password",
      "hide": "Hide password",
      "required": "Please enter your password",
      "newPassword": "New password",
      "confirmPassword": "Confirm new password",
      "tooShort": "Passwords need at least {length} characters",
      "tooLong": "That password is too long. Try a shorter one.",
      "mismatch": "Those passwords don’t match"
    },
    "video": {
      "play": "Play {title}",
      "fallbackTitle": "Video"
    },
    "image": {
      "didNotLoad": "Image failed to load"
    },
    "htmlEmbed": {
      "fallbackTitle": "Activity",
      "loading": "Loading...",
      "didNotLoad": "This activity did not load",
      "retry": "Retry",
      "rotateHint": "Turn your phone sideways for the best view"
    },
    "dailyStatsChart": {
      "modeLabel": "View",
      "modeAriaLabel": "Switch between daily counts and cumulative totals",
      "modeDaily": "Daily",
      "modeCumulative": "Cumulative",
      "tooltipHighlightedDay": "{date} · {highlight}",
      "tooltipValue": "{label}: {value}"
    },
    "classYearSelect": {
      "required": "Choose a grade"
    },
    "richTextEditor": {
      "heading": {
        "menu": "Text style",
        "paragraph": "Paragraph",
        "paragraphShort": "Text",
        "level": "Heading {level}",
        "levelShort": "H{level}"
      },
      "image": {
        "addTitle": "Insert image",
        "description": "Upload an image, add alt text for screen readers and an optional caption.",
        "editTitle": "Edit image",
        "upload": "Choose an image to upload",
        "uploading": "Uploading…",
        "removeFile": "Remove image file",
        "uploadFailed": "Upload failed",
        "alt": "Alt text (required)",
        "altPlaceholder": "Describe the image for screen readers",
        "caption": "Caption (optional)",
        "orientation": "Orientation",
        "landscape": "Landscape",
        "portrait": "Portrait",
        "insert": "Insert image",
        "update": "Update image",
        "remove": "Remove image"
      },
      "embed": {
        "addTitle": "Embed social post",
        "editTitle": "Edit social post",
        "description": "Paste a TikTok video or Instagram post link.",
        "url": "Post link",
        "urlPlaceholder": "https://www.tiktok.com/{'@'}anywayau/video/…",
        "invalid": "Open the post on the web and paste its full link, like tiktok.com/{'@'}user/video/… or instagram.com/p/…. Short app links aren’t supported.",
        "insert": "Embed post",
        "update": "Update post",
        "remove": "Remove post",
        "title": "{provider} post"
      }
    }
  }
}
